<template>
  <div :class="$style.page">
    <Title title="登录日志" />

    <Row>
      <Item title="登录时间">
        <el-date-picker
          v-model="startTime"
          type="date"
          placeholder="选择日期"
        />
        <div :class="$style.divider"></div>
        <el-date-picker v-model="endTime" type="date" placeholder="选择日期" />
      </Item>
      <Button type="primary" size="small" @click="searchLog(1)">搜索</Button>
      <Button size="small" @click="reset">重置</Button>
    </Row>

    <Divider />

    <Loading :loading="loading">
      <Title title="查询结果" :count="total">
        <span :class="$style.refresh" @click="refresh">刷新本页</span>
      </Title>

      <el-table
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{ limit * (page - 1) + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="createdTime"
          label="登录时间"
          width="120"
          align="center"
        />

        <el-table-column label="登录IP" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.ip }}（{{ scope.row.address }}）
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="loadMore"
      />
    </Loading>
  </div>
</template>

<script>
import { getLog } from "@server";
import { formatDate } from "@utils";

export default {
  name: "LoginLog",
  data() {
    return {
      startTime: "",
      endTime: "",

      page: 1,
      limit: 50,
      loading: false,
      showList: [],
      total: 0,
    };
  },
  methods: {
    async searchLog(page = 1) {
      if (this.loading) return;
      this.page = page;
      this.showList = [];
      this.loading = true;

      const params = {
        page,
        limit: this.limit,
      };
      this.startTime && (params.startTime = formatDate(this.startTime));
      this.endTime && (params.endTime = formatDate(this.endTime));

      const res = await getLog(params);
      const { code, data } = res;

      if (code === 200) {
        this.total = data.total;
        this.showList = data.list;
      } else {
        this.total = 0;
      }
      this.loading = false;
    },

    reset() {
      if (!this.startTime && !this.endTime) return;
      this.startTime = "";
      this.endTime = "";
      this.searchLog();
    },
    refresh() {
      this.searchLog(this.page);
    },
    loadMore(page) {
      this.searchLog(page);
    },
  },
  created() {
    this.searchLog();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: rem(600);
  padding: rem(50);
  padding-top: 0;

  font-size: rem(16);
  color: #333;
  background: $white;
  box-shadow: $box-shadow;

  :global {
    .gl-title {
      padding: rem(10) 0;
    }

    .gl-row {
      margin-bottom: rem(50);
    }

    .gl-item {
      margin-right: rem(30);
    }

    .el-pagination {
      @include flex();
      margin-top: rem(50);
    }
  }

  .divider {
    width: 6px;
    height: 1px;
    background: #333;
    margin: 0 7px;
  }

  .refresh {
    margin-left: rem(20);
    font-size: rem(14);
    font-weight: normal;
    color: $theme-blue-color;
    cursor: pointer;
  }
}
</style>
